var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08386 0.221865C1.41096 0.0534349 1.77818 -0.0214949 2.14511 0.00531898C2.51204 0.0321328 2.86447 0.159651 3.1636 0.373843L17.1618 10.3724C17.4211 10.5574 17.6324 10.8016 17.7782 11.0847C17.9239 11.3678 18 11.6817 18 12.0001C18 12.3186 17.9239 12.6324 17.7782 12.9156C17.6324 13.1987 17.4211 13.4429 17.1618 13.6279L3.1636 23.6264C2.86457 23.8404 2.51232 23.9679 2.14558 23.9947C1.77883 24.0215 1.41179 23.9467 1.08481 23.7784C0.757832 23.6102 0.483574 23.355 0.292189 23.0411C0.100804 22.7271 -0.000297293 22.3664 1.09755e-06 21.9987V2.0016C-0.000383998 1.63399 0.100577 1.27338 0.291789 0.959403C0.483001 0.645426 0.757064 0.390233 1.08386 0.221865V0.221865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.a7010d5cd8de97060db8df2c71c1226c.svg";
export { ForwardRef as ReactComponent };